import React, { ReactNode } from "react";
import { useSelectContext } from "./selectContext";

const Option: React.FC<{
  className?: string;
  id?: string;
  children: ReactNode | ReactNode[];
  value: string;
}> = ({ children, value, className, id }) => {
  const { changeSelectedOption } = useSelectContext();

  return (
    <li className={`py-2 px-4 cursor-pointer hover:bg-sprimary-300 hover:text-white ${className}`}
      id={id}
      onClick={() => changeSelectedOption(value)}
    >
      {children}
    </li>
  );
};

export default Option;